import { c as _c } from "react/compiler-runtime";
import { useCallback, useState } from 'react';
import { validateMessage } from '../utils';
export function useMessageValidation() {
  const $ = _c(3);
  const [errorMessage, setErrorMessage] = useState("");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = message => {
      const error = validateMessage(message);
      setErrorMessage(error);
      return !error;
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const isValid = t0;
  let t1;
  if ($[1] !== errorMessage) {
    t1 = {
      isValid,
      errorMessage
    };
    $[1] = errorMessage;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}